<template>
  <main>
      <section class="bg-white py-lg-5" style="margin-top: 3.5rem;">
          <div class="text-center container">
              <div class="row">
                <div class="col-lg-6 mt-4 order-lg-2 px-0 px-lg-3">
                      <div class="bg-flow p-5 text-white text-left mt-2">
                          <div class="d-flex mb-3">
                              <h3 class="border-super-bottom border-danger font-cursive ml-4 pr-2">{{ title }}</h3>
                          </div>
                          <h6 class="text-lead d-flex mb-3">
                              <div style="width: 30px;" class="d-flex mr-3">
                                  <i class="fa fa-phone m-auto fa-lg"></i>
                              </div>
                              <span class="font-weight-light">{{ phone }}</span></h6>
                          <h6 class="text-lead d-flex mb-3">
                              <div style="width: 30px;" class="d-flex mr-3">
                                  <i class="fa fa-envelope-o m-auto fa-lg"></i>
                              </div>
                              <span class="font-weight-light">{{ email }}</span>
                          </h6>
                          <h6 class="text-lead d-flex mb-3">
                              <div style="width: 30px;" class="d-flex mr-3">
                                  <i class="fa fa-map-marker m-auto fa-lg"></i>
                              </div>
                              <span class="font-weight-light">{{ address }}</span>
                          </h6>
                      </div>
                  </div>
                  <div class="col-md-9 col-lg-6 text-center mb-3 pt-5">
                      <h1 class="font-cursive">{{ text1 }}</h1>
                      <p class="text-lead">{{ text2 }}</p>
                  </div>
                  <div class="col-12">
                  </div>
                  <div class="col-lg-6 text-left pb-5">
                      <form @submit.prevent="handleSubmit">
                          <div class="row">
                              <div class="col-md-12">
                                  <div class="form-group">
                                      <label for="name">{{ request.name }}</label>
                                      <input type="text" v-model="data.name" class="form-control" name="name" id="name" :placeholder="request.name">
                                  </div>
                              </div>
                              <div class="col-md-6">
                                  <div class="form-group">
                                      <label for="exampleInputEmail1">{{ request.phone }}</label>
                                      <input type="text" v-model="data.phone" class="form-control" :placeholder="request.phone">
                                  </div>
                              </div>
                              <div class="col-md-6">
                                  <div class="form-group">
                                      <label for="email">{{ request.email }}</label>
                                      <input type="email" v-model="data.email" class="form-control" name="email" id="email" :placeholder="request.email">
                                  </div>
                              </div>
                              <div class="col-md-12">
                                  <div class="form-group">
                                      <label for="services">{{ request.service }}</label>
                                      <select v-model="data.service" class="form-control" name="service" id="service">
                                          <option disabled selected value> -- {{ request.service }} -- </option>
                                          <option :value="service.title" v-for="(service, index) in services" :key="index">{{ service.title }}</option>
                                      </select>
                                  </div>
                              </div>
                              <div class="col-md-12 mb-3">
                                  <div class="form-group">
                                      <label for="message">Mensaje</label>
                                      <textarea rows="3" v-model="data.commentary" class="form-control" name="commentary" id="commentary" placeholder="Mensaje"></textarea>
                                  </div>
                              </div>
                              <div class="col-md-12">
                                  <div class="p-3 rounded mb-3 d-flex" :class="result ? 'bg-success' : 'bg-danger'" v-if="message">
                                      <small class="font-weight-light text-white mx-auto">{{ message }}</small> <i class="fa fa-close text-white ml-auto mr-0 my-auto" style="cursor:pointer;" @click="message = ''"></i>
                                  </div>
                              </div>
                              <div class="col-md-12 text-center">
                                  <button type="submit" class="btn rounded-0 px-5 text-white btn-block btn-lg text-left mb-3 d-flex" style="background: #963740;">
                                    <div class="d-flex justify-content-center mr-3 my-auto" v-if="show">
                                      <div class="spinner-border spinner-border-sm text-white" role="status">
                                        <span class="sr-only">Loading...</span>
                                      </div>
                                    </div>
                                    <span class="mx-auto font-weight-light my-auto">{{ lang == 'es' ? 'Enviar' : 'Send' }}</span>
                                  </button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </section>
  </main>
</template>
<script>
import text_en from '../../text/en/contact'
import text_es from '../../text/es/contact'
export default {
  name:'contact_us',
  data: function(){
    return{
      url: window.baseURL,
      ver: true,
      result: false,
      data: {
          name: '',
          email: '',
          phone: '',
          commentary: '',
          service:''
      },
      message:'',
      show: false,
      message_show: false,
      title: window.lang == 'es' ? text_es.title : text_en.title,
      text1: window.lang == 'es' ? text_es.text1 : text_en.text1,
      text2: window.lang == 'es' ? text_es.text2 : text_en.text2,
      phone: window.lang == 'es' ? text_es.phone : text_en.phone,
      email: window.lang == 'es' ? text_es.email : text_en.email,
      address: window.lang == 'es' ? text_es.address : text_en.address,
      request: window.lang == 'es' ? text_es.request : text_en.request,
      services: window.lang == 'es' ? text_es.services : text_en.services,
      lang: window.lang
    }
  },
  methods: {
      handleSubmit(e) {
        this.show = true
        this.submitted = true
        let _this = this
        setTimeout(function () {
          const qs = require('querystring')
            const config = {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
            const requestBody = {
              name: _this.data.name,
              email: _this.data.email,
              phone: _this.data.phone,
              commentary: _this.data.commentary,
              service: _this.data.service,
            }
            axios.post(_this.url+'/api/others/abogados', qs.stringify(requestBody), config)
            .then(function (response) {
              _this.show = false
              if(response.data.result){
                _this.result = true
                _this.message = response.data.message
                _this.data = {
                  name: '',
                  email: '',
                  phone: '',
                  commentary: '',
                  service:''
                }
              }else{
                _this.result = false
                _this.message = response.data.message
              }
            })
            .catch(function (error) {
              _this.show = false
              _this.message = error
            });
        }, 1000)
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contact.vue